import { ArrowLeft } from '@phosphor-icons/react';
import { useT } from '../../i18n';

/**
 * Development only: a browser has no Telegram back button, so the manual pass
 * checks «назад» with this. Production builds drop it.
 */
export function DevBack({ onBack }: { onBack: () => void }) {
  const t = useT();
  if (!import.meta.env.DEV) return null;
  return (
    <button
      type="button"
      onClick={onBack}
      className="flex items-center gap-1 px-4 pt-2 max-w-lg mx-auto w-full text-xs text-hint"
    >
      <ArrowLeft size={12} />
      {t.common.back}
    </button>
  );
}
